import { IonButton, IonCol, IonCard, IonContent, IonItem, IonLabel, IonToggle, IonFab, IonFabButton, IonIcon, IonModal, IonPage, IonRow, IonSpinner, IonText, useIonAlert, IonSelect, IonSelectOption } from '@ionic/react';
import StarRatingComponent from 'react-star-rating-component';
import WaveHeader from '../components/WaveHeader';
import { person, location, star, diamond, storefrontSharp, checkmarkCircleOutline, starHalf, arrowForwardCircle, barbell } from 'ionicons/icons';
import useUser from '../hooks/useUser';
import PageTitle from '../components/PageTitle';
import Tag from '../components/Tag';
import { generateRandomString } from '../services/util';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import ProfileImage from '../components/ProfileImage';
import { useContext, useEffect, useState, useReducer } from 'react';
import ChallengeForm from '../components/ChallengeForm';
import Card from '../components/Card';
import ChallengesList from 'components/ChallengesList';
import useChallenges from 'hooks/useChallenges';
import VariableText from 'components/VariableText';
import WelcomeCard from 'components/WelcomeCard';
import styled from 'styled-components';
import AbsoluteSpinner from 'components/AbsoluteSpinner';
import { Users, Team } from 'services/api';
import useToast from "hooks/useToast";
import SportsAddPage from './SportsAddPage';
import ChallengesListOnlyCard from 'components/ChallengesListOnly';

import PodiumIcon from 'components/PodiumIcon';

interface TeamChallengeCreateSearchProps extends RouteComponentProps<{
	id?: string;
}> { }

const TeamChallengeCreateSearch: React.FC<TeamChallengeCreateSearchProps> = ({ match }, props) => {
	const dev = false;
	const { id } = match.params;
	const { userID } = useAuth();
	const { token } = useAuth();
	const [toast] = useToast("Hello");
	const { past } = useChallenges(id);
	const { user, userLoading } = useUser(id);
	const [showPill, setShowPill] = useState<boolean>(false);
	const [showProfileImage, setShowProfileImage] = useState<boolean>(false);
	const [showMainContent, setShowMainContent] = useState<boolean>(false);
	const [modalOpen, setModalOpen] = useState(false);
	const detailsSize = "12px";
	const [sportData, setSportData] = useState<any>([]);
  const [teamData, setTeamData] = useState<any>([]);
  const history = useHistory();

	const [sportRank, setSportRank] = useState<any>("");
	// let teamListResponse = Team.teamList(token ?? "");
	// console.log("Team list response", teamListResponse);
	let user_id = 54;
	console.log("user id", user_id);
	console.log("Match params", id);
  
  const getTeamDetails = (val:any) =>{
		 //console.log("Selected value", val);
		 history.push(`/team/edit/${val}`);
		 
	}

	const getSportsTags = () => {
		let sports: any = [];
		if (user && user?.sports.length > 0) {
			sports = user.sports;
		}

		// debugging
		let sports_display = [];
		if (sports.map !== undefined) {
			sports_display = sports
				.filter((sport_obj: any) => sport_obj._joinData.active)
				.map((sport_obj: any) => (
					<Tag
						key={generateRandomString()}
						textColor="main-text"
						color="main-text"
						onClick={() => {
							//dispatch({type: 'match_setSelectedSports', payload: [sport_obj.name]});
							//history.push('/results');
						}}
					>
						{sport_obj.name}
					</Tag>
				))
		}
		return sports_display;
	}


	async function sportActiveDeactive(id: any, check: any) {

		try {
			let post = { sport_id: id, active: check, user_id: user?.id };
			let response = await Users.updateSportsActiveDeactive(token ?? "", post);
			if (response) {
				toast({ message: response.message });
				getSportsDetails();
			}
		}
		catch {
			toast({ message: "Something went wrong" }, true);
		}
	}


	const getSportsRatings = () => {
		let sports: any = [];
		if (user && user?.sports.length > 0) {
			sports = user.sports;
		}
    console.log("selected sports", localStorage.getItem('sportsintiallySel'));
		console.log("Sports listing", sports);
		let sports_arr = [];
		if (sports.map !== undefined) {
			sports_arr = sports
				.map((sport_obj: any) => `${sport_obj.name}${sport_obj._joinData.rank}`);
		}
		let sports_str = sports_arr.join(' | ');
		return sports_str;
	}



	const getSportRankvalue = async (useridVal: any) => {
			let sportname = localStorage.getItem('sportsintiallySel');
			//console.log("Sport name", sportname);
			let userID = useridVal;
			//console.log("User ID clicked", userID);
			var response = await Users.getUserSportRank(token ?? "",sportname,userID);
			//console.log("Sport Rank", response);
			//console.log(response.payload[0].rank);
			let getrankval = response.payload[0].rank;
			//console.log("Show rank value", getrankval);
			setSportRank(getrankval);
		
	}




	const isUserProfile = () => {
		if (userID === null) return false;
		return (id === undefined || id == userID);
	}

	const getSportsDetails = async () => {
		try {
			let response = await Users.getAllUserSportList(token ?? "");
			let sports = response.payload;
			setSportData(sports);
			return sports;

		} catch (error) {
			return [];
		}
	}


	const teamList = async() => {
		  try{
           let teamListResponse = await Team.teamList(token ?? "");
					 //if (teamListResponse !== '') {
					 let team = teamListResponse.payload;
					 setTeamData(teamListResponse.payload);
					 //console.log("Team Data Value", teamListResponse.payload.length);
					 return team;
					// }

			}
			catch(error){
           return [];
			}
	}

	/*
		start at top on first render, 
		for example: when this component is used for a new user
	*/
	useEffect(() => {
		document.body.scrollTop = 0;
	}, [])



	useEffect(() => {
		setShowPill(false);
		setShowProfileImage(false);
		setShowMainContent(false);
		setTimeout(() => {
			let shouldShowPill = !!(
				(user && user.preference && (user.preference.age_range || user.preference.gender)) ||
				(user && user.preference && user.preference.location) ||
				(user && user.preference && user.preference.verified_email)
			);
			setShowPill(shouldShowPill);
			setShowProfileImage(true);
			setShowMainContent(true);
		}, 200);
		// userRefresh();
		getSportsDetails();
		//teamList();
	}, [user, id]);

  
  //console.log("Is user profile", isUserProfile);
	//console.log("User all data", user);
	
	// useEffect(() => {
	// 	getSportRankvalue(id)
	// }, [token,id]);


	return (
		<IonPage>
			<IonContent fullscreen>
				{(userLoading) ? <AbsoluteSpinner /> : null}
				{/*
					WAVE HEADER
				*/}
				<WaveHeader color="accent-two" gradient={true} loading={userLoading}>
					<IonRow>
						<ProfileDetails>
							<PageTitle
								color="main"
							>
								<VariableText text="Sleek Team" />
							</PageTitle>

							<DetailsPill show={true && !userLoading} style={{paddingTop: "14px",paddingBottom: "14px", paddingLeft: "11px", paddingRight: "11px"}}>
										<IonRow style={{ fontSize: detailsSize }} className="ion-align-items-center horizontal-gutter">
											<IonIcon style={{ marginRight: "5px" }} color="main" icon={location} />
											<IonText color="main" style={{fontWeight:600}}>Kolkata, WB</IonText>
										</IonRow>
							</DetailsPill>
						</ProfileDetails>
					</IonRow>
				</WaveHeader>

					{
								<IonButton
									expand="block"
									//routerLink="/challengelist/"{$id}
									onClick={() => {
										history.push(`/teamchallengelist/${id}`);
										}}
									style={{ margin: 14 }}
								>
									Challenge
								</IonButton>
					}                        

			        <IonText style={{ fontSize: "15px",margin: "0 5px 15px 15px" }}>Rating</IonText>
					<IonText style={{background:"transparent", color:"#000", padding:"4px 14px", borderRadius:"5px"}}>
                     {/* {user?.rating.toFixed(1)}  */}5.0
				    <IonIcon icon={star} style={{color:"#000", marginLeft: "5px", width: "15px"}} />
          </IonText>			
									
								
				
				<MainContent show={showMainContent && !userLoading}>
					<div className="horizontal-gutter" style={{ marginTop: '25px' }}>
						<IonCol className="ion-justify-content-between">
							<div>
										<IonRow style={{ flex: 1, fontSize: "20px", marginBottom: '10px', paddingLeft:"5px" }} 
													className="ion-align-items-center">
											<PodiumIcon style={{marginRight:"5px"}} />
											 <IonCol>Sports</IonCol>
											 <IonCol style={{textAlign:"right", paddingRight:"15px"}}>Rank</IonCol>
										</IonRow>
										<IonRow style={{paddingLeft:"10px"}}>
											 <IonCol>{localStorage.getItem('sportsintiallySel')}</IonCol>
											 <IonCol style={{textAlign:"right", paddingRight:"15px"}}>200</IonCol>
										</IonRow>
							</div>
							
             <br/>
						{/* <IonLabel style={{marginLeft:"10px"}}>Past Matches (Coming soon)</IonLabel> */}

						
						</IonCol>
					</div>
				</MainContent>
			</IonContent>
		</IonPage>

	);
};

export default TeamChallengeCreateSearch
const RankName = styled.div`
	width:53%;
`;
const ProfileDetails = styled(IonCol)`
	flex: 2;
`;

const DetailsPill = styled.div<{ show: boolean }>`
	background: var(--ion-color-accent-one);
	letter-spacing: 0.4px;
	padding: 10px;
	padding-left: 0;
	width: max-content;
	border-top-right-radius: 50px;
	border-bottom-right-radius: 50px;
	box-shadow: 0 0 4px rgba(13,13,13,0.3);
	transition: margin-left 0.3s;
	margin-left: ${props => `${(props.show) ? "0" : "-100%"}`};
	font-family: var(--heading-font);
	& * {
		font-size: 12px;
	}
`;

const ProfileContainer = styled.div<{ show: boolean }>`
	flex: 1;
	padding-right: 3%;
	transition: margin-right 0.3s;
	margin-right: ${props => `${(props.show) ? "0" : "-100%"}`};
`;

const MainContent = styled.div<{ show: boolean }>`
	transition: margin-top 0.3s;
	margin-top: ${props => `${(props.show) ? "0" : "150%"}`}
`;


const StatsRow = styled.div`
	width: 60px;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: end;
`;

const StatsHeaderRow = styled(StatsRow)`
	margin-bottom: 14px;
`;

const Title = styled.div`
	font-family: var(--heading-font);
`;